import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {ApiNotificationResponseDto} from '@birco/rainmesh-api';
import {CardComponent} from '../../../../shared/components/card/card.component';
import {IconComponent} from '../../../../shared/icons/icon.component';
import {RelativeDatePipe} from '../../../../shared/pipes/relative-date.pipe';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {TagComponent} from '../../../../shared/components/tag/tag.component';
import {IconsPipe} from '../../../../shared/pipes/icons.pipe';
import {Router} from '@angular/router';
import {LabelConverter} from '../../../../shared/converter/label.converter';
import {getNotificationContent} from '../../utils/notification-utils';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-notification-card',
  imports: [
    CardComponent,
    IconComponent,
    RelativeDatePipe,
    TranslatePipe,
    TagComponent,
    IconsPipe,
    NgIf
  ],
  templateUrl: './notification-card.component.html',
  styleUrl: './notification-card.component.scss'
})
export class NotificationCardComponent {
  private router = inject(Router);
  private translateService = inject(TranslateService);

  @Input() notification?: ApiNotificationResponseDto
  @Output() markAsRead = new EventEmitter<string>()

  get notificationContent() {
    return getNotificationContent(this.notification, this.translateService)
  }

  get hasLink() {
    return !!this.notificationContent.routerLink
  }

  async markAsReadAndNavigateToRouterLink() {
    if (!this.hasLink) return;

    this.markAsRead.emit(this.notification!.id)
    await this.router.navigate(this.notificationContent.routerLink!)
  }

  protected readonly LabelConverter = LabelConverter;
}
